export const updateArray = <T extends unknown>(line: T, lines: T[], updatedLine: T) => {
	const index = lines.indexOf(line);
	return [...lines.slice(0, index), updatedLine, ...lines.slice(index + 1)];
};
